import React, { useState } from "react";
import { useSignUpContext } from "../../../context/SignUpContext";
import { checkDspAccountExists, sendVerificationOTPOnSignUp } from "../../../apis/verification";
import { GLOBAL_STYLES } from "../../../appConstants";
import { Link } from "react-router-dom";
import Popup from "../../../ReusableFunctions/Popup";

export default function EmailDetailsStep() {
    const {
        signUpDetails,
        setSignUpDetails,
        setEmailMode,
    } = useSignUpContext();

    const [emailError, setEmailError] = useState("");
    const [loading, setLoading] = useState(false);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const validateEmail = (value) => {
        if (!value?.trim()) return "Email is required";
        if (!emailRegex.test(value)) return "Enter a valid email address";
        return "";
    };

    const handleEmailChange = (e) => {
        const value = e.target.value;
        setSignUpDetails((prev) => ({
            ...prev,
            email: value,
            isEmailVerified: false,
        }));
        setEmailError(validateEmail(value));
    };

    const handleSendOtp = async (typeToVerify, valueToSend) => {
        const error = validateEmail(signUpDetails?.email);
        setEmailError(error);
        if (error) return;
        if (!error && signUpDetails?.email) {
            try {
                setLoading(true);
                await checkDspAccountExists(signUpDetails?.email);
                await sendVerificationOTPOnSignUp({ [typeToVerify]: valueToSend });
                setEmailMode("VERIFY");
            } catch (err) {
                Popup.alert("Error", err || "Something went wrong while sending OTP", "ERROR");
            } finally {
                setLoading(false);
            }
        }
    };

    const isDisabled =
        loading || emailError || !signUpDetails?.email?.trim();

    return (
        <div className="w-[420px] h-[400px] py-4 mt-2">

            <p className="signUpform-title" style={{
                fontSize: "30px !important",
                fontWeight: 700
            }}>Create Your Account</p>

            <p className="font-manrope font-[600] text-[#1E1E1E] text-[17px] mt-3 mb-4">
                Enter Email
            </p>

            <div className="form-input-field">
                <div className="input-with-verify">
                    <input
                        type="text"
                        id="email"
                        name="email"
                        placeholder="Email Id"
                        value={signUpDetails?.email}
                        onChange={handleEmailChange}
                        required
                    />
                </div>
                {emailError && <div className="error-text">{emailError}</div>}
            </div>

            <button
                onClick={() => handleSendOtp('email', signUpDetails?.email)}
                disabled={isDisabled}
                className={`w-full text-white rounded-[8px] mt-8 text-[16px] font-[500] font-manrope h-[40px] text-center ${isDisabled
                    ? "bg-[#0F5EFF] opacity-60 cursor-not-allowed"
                    : "bg-[#0F5EFF] cursor-pointer"
                    }`}
            >
                {loading ? "Sending..." : "Send OTP"}
            </button>

            <p className="mt-6 text-center font-manrope font-[500] text-sm text-[#3B3B3B]">
                Already have an account?{" "}
                <Link
                    to={"/login"}
                    style={{
                        color: GLOBAL_STYLES.BG_ACTIVE,
                        textDecoration: "none",
                        fontWeight: 700,
                    }}
                >
                    Log in
                </Link>
            </p>
        </div>
    );
}
